module.exports = __webpack_public_path__ + "assets/55f1ca3df11b6701b12d5032b909d7b3.png";